import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import Print from "./details/Print";
import { useAssetsReturnModel } from "../assetsReturnModel";

export function ManageAssetsReturn() {
    const { selectedRowKeys } = useAssetsReturnModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            <Print id={selectedRowKeys[0]} />
        </>
    );
}